/**
 * 验证一个颜色是否是深色
 * @param {string} colorVal 16进制颜色值
 * @returns {boolean} 是否深色
 */
export function getColorIsDark (colorVal) {
  // 16进制颜色值的正则
  let reg = /([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // 把颜色值变成小写
  let color = colorVal.toLowerCase()
  if (reg.test(color)) {
    if (color.indexOf('#') < 0) {
      color = '#' + color
    }
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      let colorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
      }
      color = colorNew
    }
    // 处理六位的颜色值，转为RGB
    let colorChange = []
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
    }
    let grayLevel = colorChange[0] * 0.299 + colorChange[1] * 0.587 + colorChange[2] * 0.114
    // 浅色模式
    if (grayLevel < 192) {
      return true
    }
  }
  return false
}
